import type { FC } from 'react';

import { Content, StyledStatusInfoModal } from './styled';

import { Button, ButtonVariant, ButtonSize } from '../../../../../Button';
import { H1 } from '../../../../../Typography/Headings';
import { Text } from '../../../../../Typography/Text';
import { StatusInfoTypes } from '../../../StatusInfoModal';

interface ISuccess {
    onClick: () => void;
    title: string;
    text: string;
}

export const Success: FC<ISuccess> = ({ onClick, title, text }) => (
    <StyledStatusInfoModal type={StatusInfoTypes.SUCCESS}>
        <Content>
            <H1>{title}</H1>
            <Text>{text}</Text>
            <Button
                onClick={onClick}
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.SMALL}
                type="submit"
            >
                Done
            </Button>
        </Content>
    </StyledStatusInfoModal>
);
